import { Map as ImmutableMap } from 'immutable';
import { FETCH_USERS_STARTED, FETCH_USERS_SUCCEEDED, FETCH_TEAMS_STARTED, FETCH_TEAMS_SUCCEEDED } from './ActionTypes';
import { fetchUsers, fetchTeams } from '../api/usersApi';
import { arrayToMap } from '../utils/mapperUtil';
import { populateChildTeams, deriveNestedTeamIds } from '../utils/teamUtils';
import { getHasTeamsHierarchyScope } from '../selectors/authSelectors';
export function getUsers() {
  return dispatch => {
    dispatch({
      type: FETCH_USERS_STARTED
    });
    return fetchUsers().then(data => {
      dispatch({
        type: FETCH_USERS_SUCCEEDED,
        payload: arrayToMap(data, 'id')
      });
      return data;
    });
  };
}
export function getTeams({
  canViewAll,
  userPrimaryTeamId
}) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_TEAMS_STARTED
    });
    const state = getState();
    const hasTeamsHierarchy = getHasTeamsHierarchyScope(state);
    return fetchTeams().then(data => {
      let teamsMap = arrayToMap(data, 'id');

      //Since childTeams array are not initialized in our api response, we will populate them on our side before publishing to the store
      if (hasTeamsHierarchy) {
        teamsMap = populateChildTeams(teamsMap);
      }
      // If user is restrictred to a certain team, filter out the other teams
      if (userPrimaryTeamId && !canViewAll) {
        const viewableTeams = deriveNestedTeamIds(userPrimaryTeamId, teamsMap);

        // TODO: This logic should be better understood and rewritten to not overwrite teamsMaps, then can be properly typed
        teamsMap = viewableTeams.reduce((map, id) => map.set(id, teamsMap.get(+id)), ImmutableMap());
      }
      dispatch({
        type: FETCH_TEAMS_SUCCEEDED,
        payload: teamsMap
      });
      return data;
    });
  };
}